import axios, { isAxiosError } from "axios";
import { oktaAuth } from "@/auth/okta";
import type { ApiError } from "./types";

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

http.interceptors.request.use((config) => {
  const token = oktaAuth.getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(err: unknown): string {
  if (isAxiosError<ApiError>(err)) {
    return err.response?.data?.message ?? err.message;
  }
  return err instanceof Error ? err.message : "Unexpected error";
}
